import { CSSProperties } from 'react';

export const mono: CSSProperties = {
  fontFamily: 'var(--bui-font-monospace)',
  whiteSpace: 'nowrap',
};

export const panel: CSSProperties = {
  background: 'var(--bui-bg-neutral-1)',
  border: '1px solid var(--bui-border-1)',
  borderRadius: 'var(--bui-radius-3)',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  overflow: 'hidden',
};

export const tagChip: CSSProperties = {
  ...mono,
  fontSize: 12,
  padding: '1px 8px',
  borderRadius: 4,
  background: 'var(--bui-bg-neutral-2)',
  border: '1px solid var(--bui-border-1)',
  color: 'var(--bui-fg-secondary)',
};

// One home for the advisory line the pickers render under a field.
export const warnText: CSSProperties = {
  fontSize: 11.5,
  color: 'var(--bui-fg-warning)',
};
